package com.alpha.showcase.common.theme

import androidx.compose.material3.Typography
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp

// Set of Material typography styles to start with
val Typography = Typography(
  bodyLarge = TextStyle(
    fontFamily = FontFamily.Default,
    fontWeight = FontWeight.Normal,
    fontSize = 16.sp,
    lineHeight = 24.sp,
    letterSpacing = 0.5.sp
  )
  /* Other default text styles to override
    titleLarge = TextStyle(
        fontFamily = FontFamily.Default,
        fontWeight = FontWeight.Normal,
        fontSize = 22.sp,
        lineHeight = 28.sp,
        letterSpacing = 0.sp
    ),
    labelSmall = TextStyle(
        fontFamily = FontFamily.Default,
        fontWeight = FontWeight.Medium,
        fontSize = 11.sp,
        lineHeight = 16.sp,
        letterSpacing = 0.5.sp
    )
    */
)

// Material 3 typography
val materialTypography = Typography(
  headlineLarge = TextStyle(
    fontWeight = FontWeight.SemiBold,
    fontSize = 32.sp,
    lineHeight = 40.sp,
    letterSpacing = 0.sp
  ),
  headlineMedium = TextStyle(
    fontWeight = FontWeight.SemiBold,
    fontSize = 28.sp,
    lineHeight = 36.sp,
    letterSpacing = 0.sp
  ),
  headlineSmall = TextStyle(
    fontWeight = FontWeight.SemiBold,
    fontSize = 24.sp,
    lineHeight = 32.sp,
    letterSpacing = 0.sp
  ),
  titleLarge = TextStyle(
    fontWeight = FontWeight.SemiBold,
    fontSize = 22.sp,
    lineHeight = 28.sp,
    letterSpacing = 0.sp
  ),
  titleMedium = TextStyle(
    fontWeight = FontWeight.SemiBold,
    fontSize = 16.sp,
    lineHeight = 24.sp,
    letterSpacing = 0.15.sp
  ),
  titleSmall = TextStyle(
    fontWeight = FontWeight.Bold,
    fontSize = 14.sp,
    lineHeight = 20.sp,
    letterSpacing = 0.1.sp
  ),
  bodyLarge = TextStyle(
    fontWeight = FontWeight.Normal,
    fontSize = 16.sp,
    lineHeight = 24.sp,
    letterSpacing = 0.15.sp
  ),
  bodyMedium = TextStyle(
    fontWeight = FontWeight.Medium,
    fontSize = 14.sp,
    lineHeight = 20.sp,
    letterSpacing = 0.25.sp
  ),
  bodySmall = TextStyle(
    fontWeight = FontWeight.Bold,
    fontSize = 12.sp,
    lineHeight = 16.sp,
    letterSpacing = 0.4.sp
  ),
  labelLarge = TextStyle(
    fontWeight = FontWeight.SemiBold,
    fontSize = 14.sp,
    lineHeight = 20.sp,
    letterSpacing = 0.1.sp
  ),
  labelMedium = TextStyle(
    fontWeight = FontWeight.SemiBold,
    fontSize = 12.sp,
    lineHeight = 16.sp,
    letterSpacing = 0.5.sp
  ),
  labelSmall = TextStyle(
    fontWeight = FontWeight.SemiBold,
    fontSize = 11.sp,
    lineHeight = 16.sp,
    letterSpacing = 0.5.sp
  )
)

fun materialTypography(fontFamily: FontFamily) = Typography(
  displayLarge = materialTypography.displayLarge.copy(fontFamily = fontFamily),
  displayMedium = materialTypography.displayMedium.copy(fontFamily = fontFamily),
  displaySmall = materialTypography.displaySmall.copy(fontFamily = fontFamily),
  headlineLarge = materialTypography.headlineLarge.copy(fontFamily = fontFamily),
  headlineMedium = materialTypography.headlineMedium.copy(fontFamily = fontFamily),
  headlineSmall = materialTypography.headlineSmall.copy(fontFamily = fontFamily),
  titleLarge = materialTypography.titleLarge.copy(fontFamily = fontFamily),
  titleMedium = materialTypography.titleMedium.copy(fontFamily = fontFamily),
  titleSmall = materialTypography.titleSmall.copy(fontFamily = fontFamily),
  bodyLarge = materialTypography.bodyLarge.copy(fontFamily = fontFamily),
  bodyMedium = materialTypography.bodyMedium.copy(fontFamily = fontFamily),
  bodySmall = materialTypography.bodySmall.copy(fontFamily = fontFamily),
  labelLarge = materialTypography.labelLarge.copy(fontFamily = fontFamily),
  labelMedium = materialTypography.labelMedium.copy(fontFamily = fontFamily),
  labelSmall = materialTypography.labelSmall.copy(fontFamily = fontFamily),
)
